import React from 'react';
import HomePage from './home.page';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useDocumentTitle } from './env/environment-theme';
import AppHeader from './appheader/app-header';
import SecuredApp from './security/secured-app';
import intl from 'react-intl-universal';
import { defaultLocale, getTranslation, locales } from './locales/i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  useDocumentTitle('IRIS');
  intl
    .init({
      currentLocale: defaultLocale,
      locales,
    })
    .then();
  return (
    <QueryClientProvider client={queryClient}>
      <SecuredApp>
        <div>
          <AppHeader title={getTranslation('title')} />
          <main>
            <HomePage />
          </main>
        </div>
      </SecuredApp>
    </QueryClientProvider>
  );
};

export default App;
